
export const REALTIME_GPT_4_OMNI=0 //, creditsCount=4),
export const CUSTOM_GPT_4_OMNI_VOICE_TO_VOICE=5  //creditsCount=3),
/**
 * user will speak and will get TEXT response from gpt4 omni
 * - this is a cheaper model and yet convenient enough for candidates
 * @sample CUSTOM_GPT_4_OMNI_VOICE_TO_TEXT */
export const CUSTOM_GPT_4_OMNI_VOICE_TO_TEXT=6 // creditsCount=2),
